import { Pricing } from '@lib/iab/iab-vast-model';

interface IPricing {
    model: string;
    currency: string;
    _value: number;
}

const createPricing = ($pricing: IPricing): Pricing => {
    const pricing = new Pricing();
    pricing.model = $pricing.model;
    pricing.currency = $pricing.currency;
    pricing.value = $pricing._value;
    return pricing;
};

export default createPricing;
